import { createApp } from 'vue'
import ViewUIPlus from 'view-ui-plus'
import { createPinia } from 'pinia'
import piniaPluginPersist from 'pinia-plugin-persist'
import i18n from './language/index'
import * as components from './components/baseComponent/baseComponent.js'
import App from './App.vue'
// import 'default-passive-events'
import { initRouter } from './router'
import { registerStore } from './store'
import './styles/index.less'
import Directives from './directive/index.js'
import { isMobileDevice } from './utils/device.js'
import { initRem } from './utils/rem'
import { Locale } from 'vant'
import enUS from 'vant/es/locale/lang/en-US'

Locale.use('en-US', enUS)
if (isMobileDevice()) {
  initRem() // 初始化rem适配
  import('@/styles/h5/reset.css')
}

// import './mock'
const app = createApp(App)
// 全局注册组件
for (const componentItme in components) {
  app.component(componentItme, components[componentItme])
}

initRouter().then((router) => {
  app.use(ViewUIPlus).use(i18n).use(createPinia().use(piniaPluginPersist)).use(router)
  app.use(Directives)

  registerStore()
  app.mount('#app')
})
